module.exports = __webpack_public_path__ + "img/success_icon@2x.91720241.png";